import { render, staticRenderFns } from "./ClassStats.vue?vue&type=template&id=6096e116&scoped=true&"
import script from "./ClassStats.vue?vue&type=script&lang=js&"
export * from "./ClassStats.vue?vue&type=script&lang=js&"
import style0 from "./ClassStats.vue?vue&type=style&index=0&id=6096e116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096e116",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCardText,VCardTitle,VCol,VContainer,VOverlay,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6096e116')) {
      api.createRecord('6096e116', component.options)
    } else {
      api.reload('6096e116', component.options)
    }
    module.hot.accept("./ClassStats.vue?vue&type=template&id=6096e116&scoped=true&", function () {
      api.rerender('6096e116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ClassStats.vue"
export default component.exports